import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const isActive = (path: string) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navClass = (path: string) =>
    `block px-6 py-3 text-sm font-medium ${
      isActive(path)
        ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600'
        : 'text-gray-700 hover:bg-gray-50'
    }`;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-lg relative">
        <div className="p-6">
          <h2 className="text-2xl font-bold text-blue-600">LoadDrive</h2>
          <p className="text-sm text-gray-500 mt-1">Super Admin</p>
        </div>

        <nav className="mt-6">
          <Link to="/admin/dashboard" className={navClass('/admin/dashboard')}>
            📊 Dashboard
          </Link>
          <Link to="/admin/users" className={navClass('/admin/users')}>
            👥 Users
          </Link>
          <Link to="/admin/logs" className={navClass('/admin/logs')}>
            📋 Activity Logs
          </Link>
        </nav>

        <div className="fixed bottom-0 w-64 p-6 border-t bg-white">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded font-medium"
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1">
        <div className="bg-white shadow-sm border-b">
          <div className="px-8 py-4">
            <h1 className="text-2xl font-bold text-gray-900">
              {location.pathname === '/admin/dashboard' && 'Dashboard Overview'}
              {location.pathname === '/admin/users' && 'User Management'}
              {location.pathname === '/admin/logs' && 'Activity Logs'}
            </h1>
          </div>
        </div>

        <div className="p-8">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
